import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { SelectionService } from '../../../models/review/selection-service';
import { MultiDocField, MultiDocGroup } from 'src/app/models/field/multi-doc-field.model';
import { MultiDocFieldService } from '../../../services/multi-doc-field.service';
import { MultiDocPostBody } from '../../../models/review/multi-doc-post-body';
import { MultiDocEditDialogComponent } from '../../dialogs/multi-doc-edit-dialog/multi-doc-edit-dialog.component';
import { AddFieldComponent } from '../../dialogs/add-field/add-field.component';
import { CodingField } from 'src/app/models/field/coding-field.model';
import { UserConfigsService } from 'src/app/services/user-configs.service';
import { Role } from 'src/app/models/role.model';
import { SearchParameter } from '../../../models/review/search-parameter.model';
import { MultiDocEditDialogModel } from '../../dialogs/multi-doc-edit-dialog/multi-doc-edit-dialog.model';

@Component({
    selector: 'lex-multi-doc-edit',
    templateUrl: './multi-doc-edit.component.html',
    styleUrls: ['./multi-doc-edit.component.scss'],
    standalone: false
})
export class MultiDocEditComponent implements OnInit {
	@Input() expandEmailFamilySelected: boolean;
	@Input() searchParameter: SearchParameter;
	@Output() reload = new EventEmitter();

	multiDocGroups: MultiDocGroup[] = [];
	multiSelectField: MultiDocField;

	Role = Role;

	constructor(private multiDocFieldService: MultiDocFieldService, public selectionService: SelectionService, private dialog: MatDialog, public ucs: UserConfigsService) { }

	ngOnInit() {
		this.loadMultiDocGroupFields();
	}

	addDocs(matSelectChange: MatSelectChange) {
		const dialogConfig = new MatDialogConfig<MultiDocEditDialogModel>();
		dialogConfig.data = new MultiDocEditDialogModel();
		dialogConfig.data.dialogInfo = matSelectChange.value;
		dialogConfig.data.multiDocGroups = this.multiDocGroups;
		dialogConfig.data.totalDocsSelected = this.selectionService.SelectedCount;
		dialogConfig.data.expandEmailFamilySelected = this.expandEmailFamilySelected;//used only in doc-viewer
		dialogConfig.data.isDocViewer = false;
		const dialogRef = this.dialog.open(MultiDocEditDialogComponent, dialogConfig);
		dialogRef.afterClosed().subscribe((data: MultiDocPostBody | string) => {
			this.multiSelectField = null;
			if (!data) //Cancel was clicked.
				return;
			data = data as MultiDocPostBody;
			this.postMultiDoc(data);
		});
	}

	postMultiDoc(data: MultiDocPostBody) {
		data.filterId = this.selectionService.getSavedFilterId();
		data.selectedDocIds = this.selectionService.selection.selected.map(s => s.docId);
		data.allDocsSelected = this.selectionService.selectAllFlag;
		data.searchParameter = this.searchParameter;
		this.multiDocFieldService.saveMultiDocField(data)
			.subscribe(next => {
				if (next) {
					this.reload.emit();
					this.selectionService.operationAlert = 'Documents Updated.';
				}
			});
	}

	addNewField() {
		const dialogRef = this.dialog.open(AddFieldComponent);
		dialogRef.afterClosed().subscribe((data: CodingField | string) => {
			this.multiSelectField = null;
			if (!data) //Cancel was clicked.
				return;

			this.loadMultiDocGroupFields();
		});
	}

	loadMultiDocGroupFields() {
		this.multiDocFieldService.getMultiDocFields()
			.subscribe((data: MultiDocGroup[]) => {
				this.multiDocGroups = data;
			});
	}
}
